<template>
  <v-col cols="12" class="pa-0 pl-5 pr-5">
    <v-sheet rounded="lg">
      <v-container fluid>
        <h1>Login</h1>
        <paragrafo>
          O aplicativo será utilizado para realizar a validação/queima dos
          ingressos durante o evento.
        </paragrafo>
        <paragrafo
          >O Usuário responsável pela validação será cadastrado no OmniChannel,
          dentro do ambiente da loja. Após isso, cada usuário receberá por
          e-mail as informações de login, conforme abaixo:
        </paragrafo>
        <v-row justify="center" class="my-5">
          <imagem :src="image_1" />
        </v-row>
        <li>Conta: cada loja possui um número próprio;</li>
        <li>Login: e-mail informado para cadastro;</li>
        <li>Senha: senha cadastrada internamente (R).</li>
      </v-container>
    </v-sheet>
  </v-col>
</template>
<script>
export default {
  name: "login",
  components: {
    paragrafo: () => import("@/docs/components/infos/paragrafo.vue"),
    imagem: () => import("@/docs/components/infos/imagem_pos.vue"),
    // negrito: () => import("@/docs/components/infos/negrito.vue"),
  },
  data() {
    return {
      image_1: "/appValidador/validador/validador1.png",
    };
  },
};
</script>
